import React from "react";
import { useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";

const Footer = () => {

  const titleList = useSelector(state=>{
    return state.FooterTitles.value;
  });

    return(
      <>
        <footer className="footer">
          <div className="footer-inner">
            <ul className="footer-nav">
            {/* map */}
            {
              //필터 적용하려면
              //titleList.filter(id => id.id !== 6).map((id)=>
              //if문 사용할때는 return 사용
              titleList.map((id)=> (
                <li key={id.id}>
                  <strong>
                    <NavLink to={id.to}>{id.title}</NavLink>
                  </strong>
                  <ul>
                    {id.subTitles.map((subId) => {
                      const isDisabled = subId.subTo === 'support/news' || subId.subTo === 'support/questions';
                      return (
                        <li key={subId.subId}>
                          {isDisabled ? (
                            <a href="#" onClick={(e)=>{ e.preventDefault(); alert('페이지 준비 중입니다.'); }}>{subId.subTitle}</a>
                          ) : (
                            <NavLink to={subId.subTo}>{subId.subTitle}</NavLink>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </li>
              ))}
            </ul>
            <div className="footer-address">
              <h2>(주)한영디에스</h2>
              <address>
                <p>
                  <span>사업자 등록번호 : 593-88-02115</span>
                  <i>|</i>
                  <span>대표 : 황영포</span>
                  <i>|</i>
                  <span>주소 : 경기도 군포시 군포첨단산업2로22번길 5 군포산업진흥원 617호</span>
                </p>
              </address>
            </div>
          </div>
        </footer>
      </>
    );
}

export default Footer;